module.exports = __webpack_public_path__ + "static/img/Cooper-Toy.09d059d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cooper-Toy.jpg
// module id = zZSA
// module chunks = 0